import { useEffect, useState } from 'react';
import { ReactComponent as WarningIcon } from 'images/icons/warning.svg';
import { getQuote404Message } from 'services/QuoteLinkService';
import HeaderBar from './quoteLinkPage/HeaderBar';

export default function QuoteNotFound() {
  const [errorMessage, setErrorMessage] = useState('');
  const [title, setTitle] = useState('');
  const [contactInfo, setContactInfo] = useState('');
  const [contactNumber, setContactNumber] = useState('');
  const [buttonText, setButtonText] = useState('');
  const [buttonLink, setButtonLink] = useState('');
  useEffect(() => {
    const message = async () => {
      const { data } = await getQuote404Message();

      setErrorMessage(data.info);
      setTitle(data.title);
      setContactInfo(data.contactTitle);
      setContactNumber(data.contactNumber);
      setButtonText(data.buttonText);
      setButtonLink(data.buttonLink);
    };

    message();
  }, []);
  return (
    <main className="quote-not-found">
      <HeaderBar customCss="bg-[#18A8CB] navigation-container flex p-4 justify-between items-center border-b border-white/[.3] text-white" />
      <div className="h-full flex justify-center items-center">
        <div className="px-2">
          <div className="flex justify-center items-center">
            <WarningIcon />
          </div>
          <div className="max-w-[600px] text-center">
            <div className="text-[32px] leading-[40px] font-medium">
              {title || 'Your quote is no longer available'}
            </div>
            <div className="text-[16px] leading-[28px]">
              {errorMessage || 'Error message info'}
            </div>

            <div className="mt-[12px] text-[18px] font-medium leading-[28px]">
              {contactInfo || 'Contact Info'}
            </div>
            <div className="mt-[16px] text-[18px] leading-[28px]">
              {contactNumber || 'Contact Number'}
            </div>
            {buttonLink && buttonText && (
              <div className="mt-[2em]">
                <a href={buttonLink || '#'}>
                  <div className="bg-[#072636] w-[215px] m-auto text-[14px] text-[#fff] rounded-[5em] px-[30px] py-[10px]">
                    {buttonText || 'Button Text'}
                  </div>
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
    </main>
  );
}
